import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import VModal from 'vue-js-modal';

import store from './store';

import Application from './Application.vue';
import Loading from './components/Loading.vue';
import Home from './components/Home.vue';

Vue.config.productionTip = false;

require('./assets/less/global.less');

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VModal, {dynamic: true, injectModalsContainer: true});

Vue.component('loading', Loading);

const routes = [
    {path: '/', component: Home, name: 'home'}
];

const render = h => h(Application);
const router = new VueRouter({routes, mode: 'history', scrollBehavior: () => ({x: 0, y: 0})});

new Vue({render, router, store}).$mount('#application');